/**
 * Lecture centralisée de la famille machine (levage) pour la PWA.
 * Priorité : etape_2_caracteristiques_techniques_levage, puis fallback sur etape_1_infos_generales_levage.
 *
 * @param {Object} etape1 - Données etape_1_infos_generales_levage
 * @param {Object} etape2 - Données etape_2_caracteristiques_techniques_levage
 * @returns {{ code: string, nom: string, id: string, designation_id: string, designation_nom: string }}
 */
export function getFamilleLevageFromSteps(etape1, etape2) {
  const e1 = etape1 || {};
  const e2 = etape2 || {};

  const fromE2 = e2.famille_machine_code || e2.famille_machine_nom;
  if (fromE2) {
    return {
      code: e2.famille_machine_code || extractCodeFromNom(e2.famille_machine_nom) || '',
      nom: e2.famille_machine_nom || '',
      id: e2.famille_machine_id || '',
      designation_id: e2.designation_id || '',
      designation_nom: e2.designation_nom || '',
    };
  }

  return {
    code: e1.famille_machine_code || extractCodeFromNom(e1.famille_machine_nom) || '',
    nom: e1.famille_machine_nom || '',
    id: e1.famille_machine_id || '',
    designation_id: e1.designation_id || '',
    designation_nom: e1.designation_nom || '',
  };
}

function extractCodeFromNom(nom) {
  if (!nom || typeof nom !== 'string') return '';
  const m = nom.trim().match(/^(B\d+|C\d+|D\d+)/i);
  return m ? m[1].toUpperCase() : '';
}
